import { convertTradeFormEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime } from "./timeZoneService";

export const getScrubbedTradeFormEvents = (tradeFormEvents) => {
  let scrubbedTradeFormEvents = [];

  for (let i = 0; i < tradeFormEvents.length; i++) {
    let tradeFormEvent = JSON.parse(JSON.stringify(tradeFormEvents[i]));
    tradeFormEvent = convertTradeFormEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(tradeFormEvent);
    scrubbedTradeFormEvents.push(tradeFormEvent);
  }

  return scrubbedTradeFormEvents;
};

export const getScrubbedTradeFormEvent = (tradeFormEvent) => {
  let scrubbedTradeFormEvent = convertTradeFormEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(
    JSON.parse(JSON.stringify(tradeFormEvent))
  );
  scrubbedTradeFormEvent.id = scrubbedTradeFormEvent.tradeFormId
  return scrubbedTradeFormEvent;
};


